module.exports = __webpack_public_path__ + "static/media/marketing-slow-angel.3f16001e.png";